import React, { useState } from 'react';
import { Typography, Button } from '@hpstellar/core/visId';
import { withError } from '../../../../../shared/components/error-boundary';
import OfferModal from './offer-modal';
import Icon from './icon-mapper';

import './offers.less';

const OfferList = ({ offerArr, offerHeader = 'Other offers available with the product:' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const closeModal = () => setIsOpen(false);

    const [selectedProject, setSelectedProject] = useState(null);

    const list = offerArr.map(offer => (
        <>
            <div
                className={offer.type == 'gift' ? 'offer-type-gift' : 'offer-type-contingent'}
                onClick={() => {
                    setSelectedProject(offer);
                    setIsOpen(true);
                }}
            >
                {offer.type == 'gift' ? <Icon name="gift" /> : ''}
                <Typography variant="caption" className="offer-name">
                    {offer.name}
                </Typography>
            </div>
        </>
    ));

    const ModalBlock = (
        <OfferModal
            modalTitle="Offer"
            isOpen={isOpen}
            onClose={closeModal}
            className="pdp-offers"
            modalOffer={selectedProject}
        />
    );

    return (
        <>
            {offerArr.length > 0 && (
                <div className="product-offers">
                    <Typography variant="body1" className="offer-list-title">
                        {offerHeader}
                    </Typography>
                    <div className="offers-list">{list}</div>
                    {setIsOpen && ModalBlock}
                </div>
            )}
        </>
    );
};

const Offers = ({ offersList }) => {
    if (!OfferList) return null;
    return (
        <>
            <OfferList offerArr={offersList} />
        </>
    );
};

export default withError(Offers);
